/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteFacilityRegion200ResponseData
 */
export interface DeleteFacilityRegion200ResponseData {
    /**
     * 
     * @type {string}
     * @memberof DeleteFacilityRegion200ResponseData
     */
    id: string;
}

/**
 * Check if a given object implements the DeleteFacilityRegion200ResponseData interface.
 */
export function instanceOfDeleteFacilityRegion200ResponseData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function DeleteFacilityRegion200ResponseDataFromJSON(json: any): DeleteFacilityRegion200ResponseData {
    return DeleteFacilityRegion200ResponseDataFromJSONTyped(json, false);
}

export function DeleteFacilityRegion200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteFacilityRegion200ResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function DeleteFacilityRegion200ResponseDataToJSON(value?: DeleteFacilityRegion200ResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

